import { ReactNode, useMemo } from 'react';
import { useQueue } from '@shared/util/hooks/useQueue';
import { ToastContext } from './ToastContext';
import { ToastPresenter } from './ToastPresenter';
import { QueuedToast, useToastCreator } from './useToastCreator';

export function ToastProvider({ children }: { children: ReactNode }) {
  const queue = useQueue<QueuedToast>();
  const toast = useToastCreator(queue);
  const value = useMemo(() => ({ toast }), [toast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastPresenter queue={queue} />
    </ToastContext.Provider>
  );
}
